import React from "react";

// region Imports - Components
import DialogConfirmAction from "@components/Dialog/ConfirmAction";
// endregion Imports - Components
// region Imports - Languages
import { ManagementMessages, GlobalMessages } from "@shared/languages/interfaces";
// endregion Imports - Languages

interface ConfirmDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  userDetails: any;
  t: (key: string) => string;
}
const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  userDetails,
  t
}) => {
  return (
    <DialogConfirmAction
      open={open}
      onClose={onClose}
      title={title}
      actions={[
        { text: t(GlobalMessages.no).toUpperCase(), action: onClose },
        { text: t(GlobalMessages.yes).toUpperCase(), action: onConfirm }
      ]}
    >
      {t(ManagementMessages.deleteConfirmationText)} <br /><br />
      {t(ManagementMessages.dataTableName)}: {userDetails.name} <br />
      {t(ManagementMessages.dataTableEmail)}: {userDetails.email}?
    </DialogConfirmAction>
  );
};

export default ConfirmDeleteDialog;
